import React from "react";
import { useRoutes } from "react-router-dom";
import { ToastProvider } from "react-toast-notifications";

import "semantic-ui-css/semantic.min.css";
import routes from "routes/index";

import { Provider } from "react-redux";

import store from "./store";
import { ThemeProvider } from "components/ui/theme-provider";

const App = () => {
  const routing = useRoutes(routes);

  return (
    <ThemeProvider>
      <ToastProvider>
        <Provider store={store}>{routing}</Provider>
      </ToastProvider>
    </ThemeProvider>
  );
};

export default App;
